module.exports = __webpack_public_path__ + "static/media/Lydlaus.cf3f12f3.m4a";